import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
//@ts-ignore
import * as compose from 'lodash.flowright';
import { Image } from 'semantic-ui-react';

import Main from '../layouts/Main';
import Config from '../lib/Config';
import Modal from '../components/Modal';
import { __ } from '../lib/I18n';
import { asset } from '../lib/Util';
import { getNodeEnv } from '../lib/env';
import { SelectOrganizationButton } from '../components/SideMenu';
import Button from '../components/Button';

const loginError = {
  NO_ORGANIZATION: [
    __('Sua organização não possui acesso a esse serviço')
  ],
  NO_ENTITY: [
    __('Você não tem permissões para usar esse serviço.'),
    __('Solicite ao responsável pela sua organização para liberar o acesso.')
  ]
};

/**
 * @typedef {{
 *  store: import('../lib/store').PopulatedStore,
 *  router: import('next/router').NextRouter
 * }} Props
 * @extends {Component<Props>}
 */
class Index extends React.Component {
  /** @param {Props} props */
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      notAuthorized: false
    };
  }

  async componentDidMount() {
    const { store } = this.props;
    const { user, errorMessage } = store;

    if (store && user && user.organizations && user.organizations.length) {
      this.setState({
        loading: false
      });

      const hasCode = !!this.props.router?.query?.code;
      if (this.props.router.route === '/' && hasCode) this.props.router.push('/');
    } else {
      if (errorMessage) store.logout();
      this.setState({ loading: false, notAuthorized: errorMessage });
      store.setErrorMessage(null);
    }
  }

  /**
   * @param {MouseEvent} e
   */
  handleSignIn = (e) => {
    e.preventDefault();
    // @ts-ignore
    this.props.router.push(Config.loginUri[getNodeEnv()]);
  };

  render() {
    const {
      loading, notAuthorized
    } = this.state;
    const { store, router } = this.props;
    const { user } = store;

    const isHiring = !!this.props.router?.query?.hiring;

    /** @type {import('../components/SideMenu').Organization | undefined} */
    let selectedOrganization;

    if (user && user.organizations) {
      const { selectedOrganizationId, organizations } = user;
      selectedOrganization = organizations.find && organizations.find(
        organization => organization.id === selectedOrganizationId
      );
    }

    if (loading) {
      return <Main loading />;
    }

    return (
      //@ts-ignore - TODO fix has multilple children
      <Main className="landing" noHeader noSideMenu>
        <div style={{ position: 'fixed', top: '2%', left: '45%' }}>
          <Image size="small" src={asset('classapp-logo.svg')} />
        </div>
        <div className="content" style={{ position: 'absolute', marginTop: '10%', left: '15%' }}>
          {!isHiring || (user && user.accessToken && !user.notAuthorized)
            ? <h1 className="title" style={{ marginBottom: '2rem', width: '25rem' }}>{user && user.accessToken && !user.notAuthorized ? __('Escolha a instituição que deseja acessar') : __('Módulo Financeiro')}</h1>
            : <h1 className="title" style={{ marginBottom: '2rem', width: '25rem' }}>{__('Contratar Módulo Financeiro')}</h1>
          }

          <div>
            {(!user || !user.accessToken || user.notAuthorized) && (
              <div>
                <Button
                  onClick={() => this.props.router.push('/login')}
                  text={__('Entrar com a conta ClassApp')}
                  style={{ padding: '0rem 4rem', marginBottom: '2.5rem' }}
                />
                <div style={{ display: 'flex', maxWidth: '25rem', width: '100%' }}>
                  <p style={{ fontSize: 14, fontWeight: 400, color: 'rgba(0, 0, 0, 0.6)' }}>
                    {__('É necessário possuir uma conta administrativa ou ter permissão de acesso como funcionário no ClassApp.')}
                  </p>
                </div>
              </div>
            )}
            {user && user.accessToken && !user.notAuthorized && (
              <div style={{ marginTop: '1rem' }}>
                <SelectOrganizationButton
                  selectedOrganization={selectedOrganization}
                  organizations={user.organizations}
                  addOrganization={store.user.organizationsToContract.length > 0 && (() => router.push('/serviceContract'))}
                  onLogout={() => store.logout()}
                  onChooseOrganization={(chosenOrganization) => {
                    store.changeSelectedOrganization(chosenOrganization);
                  }}
                />
                <div style={{ marginTop: '2rem', position: 'relative', left: '60%' }}>
                  <Button
                    text={(
                      <div>
                        {__('Acessar')}
                        <i style={{ marginLeft: '.5rem' }} className="icon arrow right" />
                      </div>
                    )}
                    onClick={() => {
                      this.props.router.push('/entity');
                    }}
                  />
                </div>
              </div>
            )}
          </div>
          <div style={{ position: 'fixed', left: '45%', top: '20%' }}>
            <img
              alt=""
              src={asset('gif-login.gif')}
              width="497px"
              height="399px"
            />
          </div>
        </div>

        <Modal
          backgroundClassName={notAuthorized ? 'visible' : 'invisible'}
          title={__('Sem Acesso')}
          cancelEnabled={false}
          cancelButton={{ text: 'OK', action: () => this.setState({ notAuthorized: false }) }}
        >
          {/** @ts-ignore */}
          {(loginError[notAuthorized || 'NO_ENTITY'] || []).map((text, ind) => <p key={`error-text-${ind}`}>{text}</p>)}
        </Modal>
      </Main>
    );
  }
}

export default compose(
  inject('store'),
  observer
)(Index);
